// Header 
export const RULE_TYPE: string = "Rule Type";
export const ASYMMETRIC: string = "Asymmetric";
export const ASYMMETRIC_INSTRUCTIONS: string = "This will enable pair wise compatibility in single direction. Eg: Category A to Category B. Not the other way around.";
export const RULE_NAME: string = "Name";
export const RULE_NAME_INSTRUCTIONS: string = "Name must be 2-60 characters long, contain letters, numbers and spaces, and must not contain special characters.";
export const RULE_DESCRIPTION: string = "Rule Description";
export const SELECT_RULE_TYPE: string = "Select Rule Type";
export const CBA_RULE: string = "CBA";
export const CBI_RULE: string = "CBI";
export const CBM_RULE: string = "CBM";
export const CBA_INSTRUCTIONS: string = "CBA - A type of rule which computes Compatibility by Attribute (used for attribute driven rules)";
export const CBI_INSTRUCTIONS: string = "CBI - A type of rule which computes Compatibility by Item (used for mapping individual items to items)";
export const CBM_INSTRUCTIONS: string = "CBM - A type of rule which computes Compatibility by Matrix (used for mapping individual items to items)";
export const CHANGE_RULE_WARNING: string = "Changing this will delete the existing rule logic. Do you want to continue?";


export const COLUMN: string = "Column";
export const BULK_ACTION: string = "Bulk Action";
export const COMPARED_WITH: string = "is compared with";
export const ROW: string = "Row";
export const SELECT_CATEGORY: string = "Select Category";
export const SELECT_A_VALUE: string = "Select a Value";
export const DISPLAY: string = "Display";
export const PRODUCTS: string = "Products";
export const ATTRIBUTE_VALUES: string = "Attribute Values";
export const SELECT_ATTRIBUTE: string = "Select Attribute";
export const ATTRIBUTE: string = "Attribute";
export const RATING_LEVELS: string = "Rating Levels";
export const INCOMPATIBLE: string = "Incompatible";
export const BEST: string = "Compatible";
export const ADD_FILTER: string = "ADD FILTER";
export const REMOVE_FILTER: string = "REMOVE FILTER";

export const DOWNLOAD_WARNING_MESSAGE: string = 'Please save your rules before downloading ...';
export const UPLOAD_WARNING_MESSAGE: string = 'Please save your rules before uploading ...';
export const CONFIRM_PRIMARY_MESSAGE: string = 'Compatibilities should be marked as x. Note that x should be in lowercase.';
export const CONFIRM_SECONDARY_MESSAGE: string = 'Please refer to the overview page of the sheet.';
export const PREPARE_FILE_MESSAGE: string = 'Preparing file for download...';
export const TECHNICAL_ERROR_MESSAGE: string = "We're facing some technical issues, please try again...";

export const RULE_SUCCESS_MESSAGE: string = "Successfully Added Rule To Queue For Commit"

export const PRIMARY_MESSAGES = {
    level2: 'x for Compatible',
    level3: 'x for Best, and z for Good.',
    level4: 'x for Best, y for Better, and z for Good.',
};

export const COMMITT_IN_PROGRESS_MESSAGE: string = "Commiting in progress"
export const DECOMMITT_IN_PROGRESS_MESSAGE: string = "Decommitting in progress"
export const COMMITTED_MESSAGE: string = "Committed"
export const DECOMMITTED_MESSAGE: string = "Decommitted"
export const STATUS_LOOKUP = {
    "Commit_In Queue": {
        message: COMMITT_IN_PROGRESS_MESSAGE,
        bgColor: "#fff0b3",
        textColor: "#5e5942",
        loader: true,
    },
    "Commit_In Progress": {
        message: COMMITT_IN_PROGRESS_MESSAGE,
        bgColor: "#fff0b3",
        textColor: "#5e5942",
        loader: true,
    },
    Commit_Completed: {
        message: COMMITTED_MESSAGE,
        bgColor: "#e3fcef",
        textColor: "#277d60",
        loader: false,
    },
    Commit_Failed: {
        message: DECOMMITTED_MESSAGE,
        bgColor: "#fce3e3",
        textColor: "#7d2727",
        loader: false,
    },
    "Decommit_In Queue": {
        message: DECOMMITT_IN_PROGRESS_MESSAGE,
        bgColor: "#fff0b3",
        textColor: "#5e5942",
        loader: true,
    },
    "Decommit_In Progress": {
        message: DECOMMITT_IN_PROGRESS_MESSAGE,
        bgColor: "#fff0b3",
        textColor: "#5e5942",
        loader: true,
    },
    Decommit_Completed: {
        message: DECOMMITTED_MESSAGE,
        bgColor: "#fce3e3",
        textColor: "#7d2727",
        loader: false,
    },
    Decommit_Failed: {
        message: COMMITTED_MESSAGE,
        bgColor: "#e3fcef",
        textColor: "#277d60",
        loader: false,
    },
};